import {
	catchError,
	delay,
	EMPTY,
	Observable,
	of,
	switchMap,
	throwError,
} from 'rxjs';

import { ApplicationException } from 'ib/internetbank-core/ib-exceptions/ib-exceptions';

import { OperationConfirmationRequiredValidationException } from '../../../../common/exceptions/exceptions';
import { WizardConfirmationStep } from '../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-confirmation.step';
import { InsuranceSportCreateWizardComponent } from '../insurance-sport-create-wizard.component';
import { InsuranceSportConfirmDoneData, InsuranceSportDescriptionErrorCode } from '../insurance-sport-create-wizard.model';

export class InsuranceSportCreateWizardSecondStep extends WizardConfirmationStep<InsuranceSportCreateWizardComponent> {

	public onExecute(): Observable<InsuranceSportConfirmDoneData> {
		let action$: Observable<InsuranceSportConfirmDoneData>;

		if (this.wizardComponent.operationSignDocumentRequired) {
			action$ = of(null)
				.pipe(
					delay(50),
					switchMap(() => this.wizardComponent.canvasScreenshotService.makeScreenshot()),
					switchMap((screenshot: string) => this.wizardComponent.documentSignWizardService.signDocumentConfirm(
						this.stepInformation.confirmation || undefined, screenshot,
					)),
					catchError((error: ApplicationException) => {
						if (error instanceof OperationConfirmationRequiredValidationException) {
							this.form?.getControlFromAllLevels('pdfIframeControl')
								?.enable();
						}

						return throwError(() => error);
					}),
					switchMap(() => this.wizardComponent.insuranceSportCreateWizardService.confirm({
						operationId: this.wizardComponent.operationSignDocumentRequired.operationId,
						otpValue: undefined,
					})),
				);
		} else {
			action$ = this.wizardComponent.insuranceSportCreateWizardService.confirm(this.stepInformation.confirmation);
		}

		return action$
			.pipe(
				catchError((error: ApplicationException) => {
					if (error.errors && InsuranceSportDescriptionErrorCode[error.errors[0]]) {
						this.wizardComponent.messageComponent.titleText = InsuranceSportDescriptionErrorCode[error.errors[0]];
						this.wizardComponent.errorPopupId.open();

						return EMPTY;
					}

					return throwError(() => error)
				}),
			);


	}
}
